import React, { useState, useEffect, useContext } from 'react';

// Actions
import {
  deleteCodeTranslation,
  setNewCodeTranslation,
  setMaterialClassCodes,
  deleteMasterMaterialClass,
} from '../../Actions';

// MUI
import {
  makeStyles,
  TextField,
  Button,
  List,
  ListItem,
  Divider,
  Collapse,
  ListItemText,
  IconButton,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';

// Icons
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';

// Context
import { AlertContext } from '../../Context/AlertContextProvider';

const MaterialClassSettings = (props) => {
  const [matClassCdArray, setMatClassCdArray] = useState(props.matClassCdArray);
  const [codeTranslationArray, setCodeTranslationArray] = useState(
    props.codeTranslationArray
  );
  const [value, setValue] = useState(0);
  const [disabled, setDisabled] = useState(undefined);
  const [codeTranslation, setCodeTranslation] = useState({});
  const [tempCodeTranslation, setTempCodeTranslation] = useState('');
  const [materialClass, setMaterialClass] = useState('');
  const [materialClassCd, setMaterialClassCd] = useState('');
  let tempMatClassList = [];
  const [open, setOpen] = useState(undefined);
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);

  const useStyles = makeStyles((theme) => ({
    tableCells: {
      fontWeigth: 'lighter',
    },
    textField: {
      margin: 10,
    },
    addButton: {
      float: 'right',
      margin: 20,
      color: '#FF682C',
    },
    deleteButton: {
      color: '#D10000',
    },
    editButton: {
      color: 'green',
    },
    materialClassList: {
      background: '#142E3E',
      color: '#28C4FC',
      margin: 3,
      width: 600,
      [theme.breakpoints.down('sm')]: {
        width: '99%',
      },
    },
    materialClassSubList: {
      color: '#000',
      background: '#DCDCDC',
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    matClassCdArray.sort((a, b) => {
      if (a.material_class > b.material_class) {
        return 1;
      }
      if (a.material_class < b.material_class) {
        return -1;
      }
      return 0;
    });

    codeTranslationArray.forEach((element) => {
      tempMatClassList[element['code_translation_id']] =
        element['source_value'];
    });
    setCodeTranslation(tempMatClassList);
  }, [value]);

  const isDisabled = () => {
    if (materialClass === '') {
      return true;
    } else if (materialClassCd === '') {
      return true;
    } else {
      return false;
    }
  };

  const cdIsDisabled = () => {
    if (tempCodeTranslation === '') {
      return true;
    } else {
      return false;
    }
  };

  const handleClick = (index) => {
    open === index ? setOpen(undefined) : setOpen(index);
  };

  const handleDeleteMaterialClass = (id, type) => {
    deleteCodeTranslation(id, type, 'MATERIAL_CLASS_CD')
      .then(() => {
        setMessageType('success');
        setMessage('Material class deleted');
        handleAlertOpen(true);
        matClassCdArray.forEach((row, index) => {
          if (id === row.material_class_cd_id) {
            matClassCdArray.splice(index, 1);
            setValue(value + 1);
          }
        });
        codeTranslationArray.forEach((row, index) => {
          if (id === row.source_value) {
            codeTranslationArray.splice(index, 1);
            setValue(value + 1);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setMessageType('error');
        setMessage('Error deleting material class');
        handleAlertOpen(true);
      });
  };

  const handleAddCodeTranslation = (materialClassCd) => {
    if (
      codeTranslationArray.filter(
        (cd) => cd.source_value === tempCodeTranslation
      ).length > 0
    ) {
      setMessageType('error');
      setMessage('Material class code exists');
      handleAlertOpen(true);
    } else {
      setNewCodeTranslation(
        'MATERIAL_CLASS_CD',
        tempCodeTranslation,
        materialClassCd
      )
        .then(() => {
          setMessageType('success');
          setMessage('Material class added');
          handleAlertOpen(true);
          codeTranslationArray.push({
            target_value: materialClassCd,
            source_value: tempCodeTranslation,
          });
          setValue(value + 1);
        })
        .catch((err) => {
          console.log(err);
          setMessageType('error');
          setMessage('Error adding material class');
          handleAlertOpen(true);
        });
    }
  };

  const handleAddMaterialClass = () => {
    if (
      matClassCdArray.filter((cd) => cd.material_class === materialClass)
        .length > 0 ||
      matClassCdArray.filter((cd) => cd.material_class_cd === materialClassCd)
        .length > 0
    ) {
      setMessageType('error');
      setMessage('Material class/code exists');
      handleAlertOpen(true);
    } else {
      setMaterialClassCodes(materialClassCd, materialClass)
        .then(() => {
          setMessageType('success');
          setMessage('Material class added');
          handleAlertOpen(true);
          setValue(value + 1);
          matClassCdArray.push({
            material_class_cd: materialClassCd,
            material_class: materialClass,
          });
        })
        .catch((err) => {
          console.log(err);
          setMessageType('error');
          setMessage('Error adding material class');
          handleAlertOpen(true);
        });
    }
  };

  const handleNewCodeTranslation = (e) => {
    setTempCodeTranslation(e.target.value.toUpperCase());
  };

  const handleNewMaterialClassCd = (e) => {
    setMaterialClassCd(e.target.value.toUpperCase());
  };

  const handleNewMaterialClass = (e) => {
    setMaterialClass(e.target.value.toUpperCase());
  };

  const handleDeleteMasterMaterialClass = (id) => {
    deleteMasterMaterialClass(id)
      .then(() => {
        setMessageType('success');
        setMessage('Material class deleted');
        handleAlertOpen(true);
        setValue(value + 1);
        matClassCdArray.forEach((row, index) => {
          if (id === row.material_class_cd_id) {
            matClassCdArray.splice(index, 1);
            setValue(value + 1);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setMessageType('error');
        setMessage('Error deleting material class');
        handleAlertOpen(true);
      });
  };

  return (
    <div>
      <TextField
        variant="filled"
        label="Material Class"
        inputProps={{ maxLength: 20 }}
        onChange={handleNewMaterialClass}
        className={classes.textField}
      ></TextField>
      <TextField
        variant="filled"
        label="Material Class Code"
        inputProps={{ maxLength: 3 }}
        onChange={handleNewMaterialClassCd}
        className={classes.textField}
      ></TextField>
      <Button
        variant="contained"
        disabled={isDisabled()}
        className={classes.addButton}
        onClick={handleAddMaterialClass}
      >
        Add
      </Button>
      <List component="nav" aria-labelledby="nested-list-subheader">
        {matClassCdArray.sort().map((row, index) => {
          return (
            <List key={index} className={classes.materialClassList}>
              <ListItem button onClick={() => handleClick(index)}>
                <ListItemText primary={row.material_class} />
                {open === index ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Divider />
              {open === index ? (
                <Collapse in={true} timeout="auto" unmountOnExit>
                  <List className={classes.materialClassSubList} key={index}>
                    <ListItem>
                      <ListItemText secondary="Alt. Material Class Code" />
                      <TextField
                        variant="filled"
                        label="Material Class Code"
                        inputProps={{ maxLength: 20 }}
                        className={classes.textField}
                        onChange={handleNewCodeTranslation}
                      ></TextField>
                      <Button
                        variant="contained"
                        disabled={cdIsDisabled()}
                        className={classes.addButton}
                        onClick={(e) =>
                          handleAddCodeTranslation(row.material_class_cd)
                        }
                      >
                        Add
                      </Button>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <Typography variant="h5">
                        Delete Material Class:
                      </Typography>
                      <Button
                        variant="contained"
                        className={classes.addButton}
                        onClick={() =>
                          handleDeleteMasterMaterialClass(
                            row.material_class_cd_id
                          )
                        }
                      >
                        Delete
                      </Button>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <ListItemText
                        primary="Master Material Class Code"
                        secondary={row.material_class_cd}
                      />
                    </ListItem>
                    <Divider />
                    {codeTranslationArray.map((row, i) => {
                      return (
                        row.target_value ===
                          matClassCdArray[index].material_class_cd && (
                          <div key={i}>
                            <ListItem>
                              <ListItemText
                                primary={'Alt. Material Class Code'}
                                secondary={row.source_value}
                              />
                              <ListItemSecondaryAction>
                                <IconButton
                                  edge="end"
                                  aria-label="delete"
                                  onClick={() =>
                                    handleDeleteMaterialClass(
                                      row.source_value,
                                      'delete'
                                    )
                                  }
                                >
                                  <DeleteIcon
                                    className={classes.deleteButton}
                                  />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                          </div>
                        )
                      );
                    })}
                    <Divider />
                    <></>
                  </List>
                </Collapse>
              ) : (
                <></>
              )}
            </List>
          );
        })}
      </List>
    </div>
  );
};

export default MaterialClassSettings;
